import ArrowUpward from '@mui/icons-material/ArrowUpward';
import { Button } from '@mui/material';
import React from 'react';

export const BackToTopButton: React.FC<{ handleScrollToTop: () => void }> = ({
  handleScrollToTop
}) => {
  return (
    <Button
      startIcon={<ArrowUpward />}
      sx={{
        variant: 'contained',
        position: 'absolute',
        bottom: 30,
        backgroundColor: ({ palette }) => `${palette.primary.main}90`,
        color: 'white',
        left: '50%',
        transform: 'translateX(-50%)'
      }}
      onClick={handleScrollToTop}
    >
      Back to Top
    </Button>
  );
};
